//AHW Sticky header
$(function () {
  var e = $(document).scrollTop();
  var t = $(".custom-header").outerHeight();
  $(window).scroll(function () {
    var n = $(document).scrollTop();
    if ($(document).scrollTop() >= 100) {
      $(".custom-header").css("position", "fixed");
    }
    if (n > t) {
      $(".custom-header").addClass("scroll");
    } else {
      $(".custom-header").removeClass("scroll");
    }
    if (n > e) {
      $(".custom-header").removeClass("no-scroll");
    } else {
      $(".custom-header").addClass("no-scroll");
    }
    e = $(document).scrollTop();

  });
});

// Custom layout menu

$('.custom-header-close').on('click', function () {
  $('.custom-header-menu-co').fadeOut(300)
})

$('.custom-header-menu').on('click', function () {
  $('.custom-header-menu-co').fadeIn(300)
})

$(".game-slider").not('.slick-initialized').slick({
  slidesToShow: 1,
  dots: true,
  rtl: true,
  infinite: false,
  arrows: true,
  slidesToScroll: 1,
  prevArrow: '<div class="a-right control-c prev slick-prev slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"></path></svg></div>',
  nextArrow: '<div class="a-right control-c next slick-next slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"></path></svg></div>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false

      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false

      }
    },
    {
      arrows: false
    }
  ]
});
$(".suggestion-games-items").not('.slick-initialized').slick({
  slidesToShow: 7,
  dots: false,
  infinite: false,
  rtl: true,
  arrows: true,
  slidesToScroll: 7,
  prevArrow: '<div class="a-right control-c prev slick-prev slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"></path></svg></div>',
  nextArrow: '<div class="a-right control-c next slick-next slick-arrow" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"></path></svg></div>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: false

      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false

      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false
      }
    }
  ]
});